import "./custom-tab.scss";
import m from "mithril";
export default () => {
	let currentindex = 0;
	return {
		oninit: ({attrs: {initialindex}}) => {
			if (initialindex && initialindex > 0) currentindex = initialindex;
		},
		view: ({attrs: {labels, tab}}) => {
			return m(".custom-tab-container-wrapper", [
				m(".tab-list", [
					(labels || ["tab 0"]).map((t, i) => {
						return m(
							".tab-label",
							{
								onclick: () => {
									currentindex = i;
								},
								class: currentindex == i ? "selected" : "",
							},
							t
						);
					}),
				]),
				m(".tab-content-container", tab ? tab(currentindex) : null),
			]);
		},
	};
};
